<template>
  <div id="app">
    <TopMenu/>
    <transition name="show-modal">
      <AppModal />
    </transition>
    <transition name="fade-auth" mode="out-in" appear>
      <div v-if="isLoggedIn" :key="1">
        <Dashboard/>
      </div>
      <div v-else :key="2">
        <Authentication/>
      </div>
    </transition>
  </div>
</template>
<script>
import TopMenu from "@/components/TopMenu.vue";
import Authentication from "@/views/Authentication.vue";
import Dashboard from "@/components/Dashboard.vue";
import AppModal from "@/components/AppModal.vue";

export default {
  name: "home",
  components: {
    TopMenu,
    Dashboard,
    Authentication,
    AppModal
  },
  methods: {
    showModal(componentName) {
      this.$store.commit("showModal", componentName);
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  }
};
</script>

<style lang="scss">
@import "@/fonts/fonts.montserrat.scss";
@import "@/styles/style.scss";
@import "@/styles/animations.scss";
</style>
